var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMotorcycle, faTruck, faBolt, faClock, faShippingFast, } from "@fortawesome/pro-light-svg-icons";
//modules
import EnvioGratis from "./EnvioGratisProducto";
var TipoDeEnvioProducto = function (_a) {
    var enviosDisponibles = _a.enviosDisponibles, producto = _a.producto;
    return (React.createElement(ContainerTipoEnvio, null, enviosDisponibles && producto ? (enviosDisponibles.envioFlashUnaHora && producto.tipo_envio === 1 ? (React.createElement(Envio, { envioFlash: true },
        React.createElement(FontAwesomeIcon, { icon: faBolt }),
        React.createElement("span", null,
            React.createElement(TextOnDesktop, null, "Env\u00EDo en "),
            React.createElement("b", null, "1 hora"),
            React.createElement(EnvioGratis, { esGratis: producto.envio_gratis })))) : enviosDisponibles.envioFlashDosHoras &&
        producto.tipo_envio === 1 ? (React.createElement(Envio, { envioFlash: true },
        React.createElement(FontAwesomeIcon, { icon: faMotorcycle }),
        React.createElement("span", null,
            React.createElement(TextOnDesktop, null, "Env\u00EDo en "),
            React.createElement("b", null, "2 horas"),
            React.createElement(EnvioGratis, { esGratis: producto.envio_gratis })))) : enviosDisponibles.envioFlashEnLaManiana &&
        producto.tipo_envio === 2 ? (React.createElement(Envio, { envioFlashEnLaManiana: true },
        React.createElement(FontAwesomeIcon, { icon: faClock }),
        React.createElement("span", null,
            React.createElement(TextOnDesktop, null, "Recibilo "),
            React.createElement("b", null, "en la ma\u00F1ana"),
            React.createElement(EnvioGratis, { esGratis: producto.envio_gratis })))) : enviosDisponibles.envioExpress ? (React.createElement(Envio, { envioExpress: true },
        React.createElement(FontAwesomeIcon, { icon: faShippingFast }),
        React.createElement("span", null,
            React.createElement(TextOnDesktop, null, "Env\u00EDo en "),
            React.createElement("b", null, "1 d\u00EDa"),
            React.createElement(EnvioGratis, { esGratis: producto.envio_gratis })))) : enviosDisponibles.envioFull ? (React.createElement(Envio, { envioFull: true },
        React.createElement(FontAwesomeIcon, { icon: faTruck }),
        React.createElement("span", null,
            "Env\u00EDo r\u00E1pido",
            React.createElement(EnvioGratis, { esGratis: producto.envio_gratis })))) : null /*falta usuario no logueado y si no es en dos horas ver aviso-tipo-envio.php */) : null));
};
var TextOnDesktop = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media screen and (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  @media screen and (max-width: ", ") {\n    display: none;\n  }\n"])), function (props) { return props.theme.breakPointMedium; });
var ContainerTipoEnvio = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n\n  svg {\n    margin-right: 5px;\n  }\n"], ["\n  flex: 1;\n\n  svg {\n    margin-right: 5px;\n  }\n"])));
var Envio = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n\n  font-size: 12px;\n  font-weight: bold;\n  text-decoration: none;\n  text-align: ", ";\n"], ["\n  color: ", ";\n\n  font-size: 12px;\n  font-weight: bold;\n  text-decoration: none;\n  text-align: ", ";\n"])), function (props) {
    return props.envioFlash
        ? "#0c6600"
        : props.envioFlashEnLaManiana
            ? "#250055"
            : props.envioExpress
                ? "#014ECB"
                : props.envioFull
                    ? "#0059ff"
                    : "#000C24";
}, function (props) { return props.theme.infoDeTipoDeEnvioTextAlign; });
export default TipoDeEnvioProducto;
var templateObject_1, templateObject_2, templateObject_3;
